// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cdb-rdb[data-v-3b872082] {\r\n  margin-top: 0 !important;\r\n  width: 100%;\r\n  padding-top: 0 !important;\r\n  padding-bottom: 5rem;\n}\n.formulario[data-v-3b872082] {\r\n  margin-top: 2rem;\r\n  width: 100%;\n}\n.input[data-v-3b872082] {\r\n  width: 100% !important;\n}\n.line[data-v-3b872082] {\r\n  padding: 0 !important;\n}\n.column[data-v-3b872082] {\r\n  padding-bottom: 0;\n}\n.content[data-v-3b872082] {\n}\r\n", ""]);
// Exports
module.exports = exports;
